import React, { useCallback } from 'react';
import Seo from '../components/Seo';

const StaticDoc = ({ type }) => {
  const isPrivacy = type === 'privacy';
  const src = isPrivacy ? '/Privacy.html' : '/Terms.html';
  const onLoad = useCallback((e) => {
    try {
      const iframe = e.currentTarget;
      const doc = iframe.contentDocument || iframe.contentWindow?.document;
      if (!doc) return;
      const style = doc.createElement('style');
      style.textContent = `
        .header, footer.footer { display: none !important; }
        body { background: transparent !important; }
        main { 
          max-width: 1000px !important; 
          margin: 0 auto !important; 
          box-shadow: none !important; 
          border: none !important;
        }
      `;
      doc.head && doc.head.appendChild(style);
    } catch (_) {}
  }, []);
  return (
    <>
      <Seo
        title={isPrivacy ? 'Privacy Policy' : 'Terms & Conditions'}
        description={
          isPrivacy
            ? 'KeepMyAsset Privacy Policy: how we collect, use, and protect your asset and nominee data, your rights, and how we may update this policy.'
            : 'KeepMyAsset Terms & Conditions: service use, limitations of liability, data responsibility, and our right to update terms at any time.'
        }
        path={isPrivacy ? '/privacy' : '/terms'}
      />
    <div style={{ width: '100%', margin: '0 auto', padding: '12px 0 24px' }}>
      <iframe
        title={type === 'privacy' ? 'Privacy Policy' : 'Terms & Conditions'}
        src={src}
        onLoad={onLoad}
        style={{ width: '100%', minHeight: '80vh', border: 'none' }}
      />
    </div>
    </>
  );
};

export default StaticDoc;


